export enum AuthActionTypes {
  Login = '[User Component] User login',
  LoginSuccess = '[User Component] User loging success',
  LoginFailed = '[User Component] User loging failed',
  Logout = '[User Component] User logout',

  Register = '[User Component] User register',
  RegisterResponse = '[User Component] User register response',
  RegisterFailed = '[User Component] User register failed',

  Recovery = '[User Component] User account recovery',
  RecoveryFailed = '[User Component] User account recovery failed',
  RecoverySuccess = '[User Component]  User account recovery success',

  ResetAuthErrorMessage = '[User Component] Reset auth error message'
}

export enum UserActionTypes {
  UpdatePointsCount = '[User Component] Points Count updated',
  MarkAllNotificationsAsRead = '[User Component] Mark all notifications as read',
  MarkOneNotificationAsRead = '[User Component] Mark one notification as read',
  SetUnreadNotificationsCount = '[User Component] Set unread notifications count'
}

export enum ButtonSelectionActionTypes {
  StatusBarModuleSelected = '[Buttons Component] Status bar module selected',
  DisableTaskBarButtonNavigation = '[Buttons Component] Task-Bar buttons disabled'
}
